import React from 'react';
import {Box, Button, ModalContent, ModalContentText} from "@deere/fuel-react";
import WarningIcon from '@material-ui/icons/Warning';
import DeleteIcon from "@material-ui/icons/Delete";

export const CriteriaModalContent = ({content}) => {
    return (
        <ModalContent dividers>
            <Box display="flex" alignItems="center">
                <Box pr={2}>
                    <WarningIcon fontSize="large" style={{fill: "#fab64c"}}/>
                </Box>
                <Box>
                    <ModalContentText id="alert-Modal-description">
                        {content}
                    </ModalContentText>
                </Box>
            </Box>
        </ModalContent>
    );
};

export const CriteriaModalButton = ({titleText, handleClickOpen, type}) => {
    return (
        <>
            {type === "range" ? <Button variant="text" style={{ marginRight: "1rem" }} onClick={handleClickOpen}><DeleteIcon />&nbsp; Delete</Button> :
                <Button variant="text" size="large" style={{ marginRight: "1rem" }} onClick={handleClickOpen}>
                    {titleText}
                </Button>
            }
        </>
    );
};



